import { engagementsString  } from './adapters';
import categoryPageAttributes from '../../category-page-attributes';

export const facetEngagementDatalayerEvent = (datalayer, queryString, props, facetData) => {
  try {
    datalayer.link({
      event_name: 'refinement',
      ...categoryPageAttributes(props),
      facet_engagement: engagementsString({ queryString, facetData }),
    });
  } catch (err) {
    datalayer.link({
      business_unit_id: props.businessUnitId,
      error_message: `[Facet Engagement Data Layer]: error: ${err.message}`,
    });
  }
};
